import styled, { css } from 'styled-components';
import { AlignTypes, TabsSize } from './types';

export const TabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  width: 100%;
  background-color: transparent;
  border-radius: 10px 10px 0 0;
  flex: 1;
`;

export const TabsSection = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  background-color: transparent;
  overflow-x: auto;
  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
    width: 4px;
    height: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background: #cccccc;
    border-radius: 10px;
    width: 4px;
    height: 4px;
  }
`;

export const ContentSection = styled.div<{ swipeable?: boolean }>`
  box-sizing: border-box;
  height: 100%;
  max-width: 100%;
  flex: 1;
  overflow: hidden;
  ${({ swipeable }) =>
    swipeable &&
    css`
      display: flex;
    `}
`;

export const RenderTab = styled.div<{
  length: number;
  active: boolean;
  index: number;
  fullWidth: boolean;
  disabled: boolean;
  size: TabsSize;
  align: AlignTypes;
  adjustableWidth: boolean;
  width: string;
}>`
  ${({ size, theme, active, disabled, index, length, adjustableWidth }) => {
    switch (size) {
      case 'minimal':
        return css`
          background-color: transparent;
          border-bottom: 2px solid ${active ? theme.tabs.active : 'transparent'};
          box-sizing: content-box;
          color: ${
            // eslint-disable-next-line no-nested-ternary
            disabled ? theme.tabs.disabled : active ? theme.tabs.active : theme.gray80
          };
          font-size: 20px;
          font-weight: 800;
          min-width: ${!adjustableWidth && `${theme.tabs.minimalWidth}px`};
          padding-bottom: 12px;
          transition: border 0.5s ease;
        `;
      default:
        return css`
          background-color: ${theme.white};
          border: 1px solid ${theme.grayCC};
          border-radius: ${
            // eslint-disable-next-line no-nested-ternary
            index === 0 ? '10px 0 0 10px' : index < length - 1 ? '0' : '0 10px 10px 0'
          };
          border-width: ${index !== length - 1 ? '1px 0px 1px 1px' : '1px 1px 1px 1px'};
          box-sizing: border-box;
          color: ${
            // eslint-disable-next-line no-nested-ternary
            disabled ? theme.tabs.disabled : active ? theme.tabs.active : theme.gray4D
          };
          font-size: 16.4627px;
          font-weight: 600;
          min-width: ${!adjustableWidth && `${theme.tabs.width}px`};

          padding-left: 30px;
          padding-right: 30px;
        `;
    }
  }}
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? 'defaul' : 'pointer')};
  display: flex;
  flex: ${({ fullWidth }) => (fullWidth ? '1' : '')};
  flex-shrink: 1;
  gap: 21px;
  height: ${({ size, theme }) => `${theme.tabs.height[size]}px`};
  justify-content: ${({ theme, align }) => theme.tabs.align[align]};
  line-height: 21px;
  text-align: ${({ align }) => align};
  width: ${({ width }) => width && `${width}`};
  word-break: ${({ adjustableWidth }) => adjustableWidth && `break-all`};
`;

export const ContentWrapper = styled.div<{ swipeable?: boolean }>`
  height: 100%;
  ${({ swipeable }) =>
    swipeable &&
    css`
      display: flex;
      flex-direction: column;
      flex: 0 0 100%;
      user-select: none;
      overflow-y: auto;
    `}
`;

export const TabsWrapper = styled.div<{ height: string }>`
  height: ${({ height }) => height};
  width: 100%;
`;

export const Slider = styled.div`
  display: flex;
  gap: 16px;
  height: 100%;
  will-change: transform;
`;

export const SliderContainer = styled.div`
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;
`;
